const initialState = {
};

export default function anggaranReducer(state = initialState, action) {
  switch (action.type) {
  case 'POST_DATA_ANGGARAN':
    return action.data;
  case 'GET_DATA_ANGGARAN':
    return {
      ...state,
      dataAnggaran: action.data
    };
  case 'GET_DATA_BULAN_ANGGARAN':
      return {
        ...state,
        dataBulan: action.data
      };
  default:
    return state;
  }
}